import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { OutputConfigDialog } from "../OutputConfigDialog/OutputConfigDialog.logic";
import { IRootState } from "../../../../reducer/CombineReducer";
import { OutputConfigLandingPageView } from "./OutputConfigLandingPage.view";
import "../Style.scss";

export const OutputConfigLandingPage: React.FC = () => {
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const [showDialog, setShowDialog] = useState(false);
  const selectedConfig = outputConfig?.selectedOutputConfig?.id;

  useEffect(() => {
    setShowDialog(Boolean(selectedConfig));
  }, [selectedConfig]);

  return (
    <>
      <OutputConfigLandingPageView />
      {showDialog &&
        <OutputConfigDialog show={showDialog} />
      }
    </>
  );
};
